import React from 'react';
import { TooltipH } from './TooltipH';
import { Preloader, Preloader0 } from './kit';

export function Button(props) {

  const {
    onClick = () => void (0),
    children,
    icon = '',
    iconAfter = '',
    iconMobileOnly,
    iconDesktopOnly,
    loading,
    ghost,
    red,
    flat,
    sm,
    inactive,
    disabled,
    tooltip,
    tooltipMobileOff,
    tooltipPlacement,
    className,
    style = {},
    onMouseEnter,
    onMouseOver,
    onMouseOut,
    labelMobileOff,
  } = { ...props }

  const hasLabel = React.Children.toArray(children).some((child) => (
    typeof child === 'string' || typeof child === 'number'
      ? String(child).trim() !== ''
      : Boolean(child)
  ));
  const iconOnly = Boolean(icon) && !loading && !hasLabel;

  if (!tooltip) return (
    <>
     <ButtonInner
      iconOnly={iconOnly}
      {...props}
      />
    </>
  )
  if (tooltip) return (
    <>
      <TooltipH
        mobileOff={tooltipMobileOff}
        placement={tooltipPlacement}
        title={<>{tooltip}</>}
      >
        <ButtonInner
          iconOnly={iconOnly}
          {...props}
        />
      </TooltipH >
    </>
  )
}



const ButtonInner = React.forwardRef(({
  onClick,
  onMouseEnter,
  onMouseLeave,
  onMouseOut,
  onMouseOver,
  onFocus,
  onBlur,
  sm,
  iconOnly,
  iconMobileOnly,
  iconDesktopOnly,
  labelMobileOff,
  style,
  className,
  children,
  icon,
  flat,
  inactive,
  disabled,
  iconAfter,
  loading,
  ghost,
  red,
}, ref) => {

  return (<div
  ref={ref}
  style={{ ...style }}
  onClick={typeof onClick === 'function' ? onClick : void(0)}
  onMouseEnter={typeof onMouseEnter === 'function' ? onMouseEnter : void(0)}
  onMouseLeave={typeof onMouseLeave === 'function' ? onMouseLeave : void(0)}
  onMouseOut={typeof onMouseOut === 'function' ? onMouseOut : void(0)}
  onMouseOver={typeof onMouseOver === 'function' ? onMouseOver : void(0)}
  onFocus={typeof onFocus === 'function' ? onFocus : void(0)}
  onBlur={typeof onBlur === 'function' ? onBlur : void(0)}
  className={`x_button ${sm ? 'x_button--sm' : ''} ${iconOnly ? 'x_button--icon-only' : ''} ${labelMobileOff ? 'x_button--labelmobileoff' : ''} ${ghost ? 'x_button--ghost' : ''}  ${red && !disabled ? 'x_button--red' : ''} ${flat ? 'x_button--flat' : ''} ${inactive ? 'x_button--inactive' : ''} ${disabled ? 'x_button--locked' : ''} ${icon && !iconOnly ? 'x_button--withicon' : ''} ${className ? `${className}` : ''}`}
>
  {Boolean(icon) && !loading &&
    <div className={`x_button_icon ${iconMobileOnly ? 'mobile_vh_yes' : ''} ${iconDesktopOnly ? 'mobile_vh_no' : ''}`}>
      <div className="t_icon">{icon}
      </div>
    </div>}
  {loading &&
    <div className="x_button_icon x_button_icon--loading">
      <Preloader0 invert style={{ width: 36, height: 36, position: 'relative', margin: '-0.8em', marginLeft: '-0.7em', marginRight: '-0.9em' }}><Preloader invert width={36} height={36} /></Preloader0>
    </div>}
  {labelMobileOff && <span className="mobile_v_no">
    {children}
  </span>}
  {!labelMobileOff && children}
  {Boolean(iconAfter) &&
    <div className="x_button_icon">
      <div className="t_icon">{iconAfter}
      </div>
    </div>}
  </div>)
});